var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iconify-icon',_vm._g({staticClass:"zp-icon",style:(_vm.colorStyle),attrs:{"icon":_vm.iconRef,"width":_vm.size,"height":_vm.size,"aria-hidden":_vm.ariaHiddenAttr,"aria-label":_vm.ariaLabel || null,"role":_vm.ariaLabel ? 'img' : null}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }